import { memo } from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'

import SummaryIcon from './SummaryIcon'

const SummaryWidget = ({ title, value, icon, sx, ...other }) => {
  return (
    <Card
      sx={[
        () => ({
          width: 1,
          p: 2,
          pl: 3,
          display: 'flex',
          alignItems: 'center'
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...other}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ color: 'text.secondary', typography: 'subtitle2' }}>
          {title}
        </Box>
        <Box sx={{ my: 1.5, typography: 'h3' }}>{value}</Box>
      </Box>
      <SummaryIcon icon={icon} />
    </Card>
  )
}

export default memo(SummaryWidget)
